import { nextTick, type Ref } from "vue";
import { createI18n } from "vue-i18n";
import { SupportedLocales, type MessageSchema } from "./types";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

const i18n = createI18n<[MessageSchema], SupportedLocales>({
  legacy: false,
  locale: SupportedLocales.FR,
  fallbackLocale: SupportedLocales.FR,
  messages: {
    [SupportedLocales.EN]: en,
    [SupportedLocales.FR]: fr,
  },
});
loadLocale(SupportedLocales.FR);

export async function setI18nLanguage(locale: SupportedLocales) {
  await loadLocale(locale);
  (i18n.global.locale as unknown as Ref).value = locale;
  document.querySelector("html")?.setAttribute("lang", locale);
}

export async function loadLocale(locale: SupportedLocales) {
  // load locale messages with dynamic import
  const messages = await import(`./locales/${locale}.json`);
  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default);

  return nextTick();
}

export default i18n;
